import { jsx as _jsx } from "react/jsx-runtime";
import { Collection, Card, CardBody, } from '../styleguide/components';
export const CollectionWithCard = ({ children }) => (_jsx(Card, { children: _jsx(CardBody, { children: _jsx(Collection, Object.assign({ className: "c-collection c-collection--unbox" }, { children: children })) }) }));
